import React from "react"

function AlarmClock({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      {...props}
    >
      <path
        d="M16.2941 10.6521C11.7161 11.5303 8.71653 15.9536 9.59469 20.5317C10.4723 25.1071 14.8989 28.1088 19.4743 27.2311C24.0497 26.3535 27.0514 21.9269 26.1738 17.3515C25.5558 14.1301 23.1276 11.5582 19.9466 10.7562"
        stroke="#003E4C"
        strokeWidth="1.00184"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.8844 18.9419V24.0933"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8832 18.9419L21.5531 15.3268"
        stroke="#003E4C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.676 9.18036C13.676 9.18036 13.7067 8.74395 13.7414 8.25173C13.7597 7.9975 13.6305 7.75537 13.4092 7.62851C13.1884 7.50142 12.914 7.51226 12.7038 7.65573C11.5216 8.46263 9.68004 9.71951 8.49817 10.5262C8.28759 10.6699 8.17788 10.9212 8.21539 11.1734C8.25325 11.4254 8.43168 11.634 8.6747 11.7098C9.21316 11.8776 9.71292 12.0337 9.71292 12.0337"
        stroke="#003E4C"
        strokeWidth="0.987212"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M22.0989 9.17989C22.0989 9.17989 22.069 8.75636 22.0346 8.27248C22.0168 8.01446 22.1478 7.76811 22.3724 7.63946C22.5966 7.51058 22.8752 7.52159 23.0887 7.66732C24.2654 8.47045 26.0823 9.71052 27.2591 10.5137C27.473 10.6596 27.5843 10.9148 27.5464 11.1708C27.5081 11.4266 27.3268 11.6386 27.0796 11.7158C26.5491 11.8815 26.062 12.0332 26.062 12.0332"
        stroke="#003E4C"
        strokeWidth="0.987212"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />{" "}
    </svg>
  )
}
export default AlarmClock
